import { useQuery } from '@tanstack/react-query';

import { getV1BusinessPartnersOptions } from '../../api/generated/pm/@tanstack/react-query.gen';

/**
 * Query hooks for the Organizations support-search page.
 *
 * The page fetches up to a thousand matching organizations in one request and
 * paginates client-side, so the query is pinned to `page: 1, limit: 1000`.
 */

export function useOrganizations({ search, isEnabled }: { search?: string; isEnabled?: boolean }) {
  return useQuery({
    ...getV1BusinessPartnersOptions({ query: { page: 1, limit: 1000, search } }),
    enabled: isEnabled && (search === undefined || search.length >= 4),
  });
}
